export const sortByAsc = (a, b) => a - b;
export const sortByDesc = (a, b) => b - a;
export const sortByOrder = (arr, order) => arr.sort((a, b) => order.indexOf(a) - order.indexOf(b));
